module.exports = __webpack_public_path__ + "img/logo_skanaa.43880cce.png";